import styled from 'styled-components'

export const StyledLabel = styled.div`
  margin: 15px 0 30px;
  color: white;
`

StyledLabel.displayName = 'StyledLabel'



// WEBPACK FOOTER //
// ./src/app/StyledLabel.js